<template>
  <q-dialog
    v-model="shown"
    transition-show="fade-in"
    transition-hide="fade-out"
    :maximized="maximized"
  >
    <q-card
      v-if="currentUser"
      :class="maximized ? 'fixed-full column justify-between' : undefined"
      style="overflow: hidden;"
    >
      <q-card-section
        class="q-pa-none col"
      >
        <div
          class="row items-center q-pt-lg q-pa-sm q-gutter-sm bg-primary"
          :class="$getTextColor(currentSite, 'primary')"
        >
          <div
            class="col row justify-start items-center"
            style="flex-grow: 1"
          />
          <div class="col-auto text-h6">
            Transfer Tab
          </div>
          <div
            class="col row justify-end"
            style="flex-grow: 1"
          >
            <q-btn
              icon="close"
              flat
              round
              dense
              @click="shown = false"
            />
          </div>
        </div>

        <q-card
          style="max-height: calc(100% - 70px); overflow: hidden;"
        >
          <q-card-section class="row justify-between items-center">
            <div class="text-body1 text-bold col">
              Select transfer recipent
            </div>
            <q-toggle
              v-if="currentUser.admin"
              v-model="force"
              class="col-auto"
              color="primary"
              label="Force Transfer"
              size="sm"
            />
          </q-card-section>

          <q-item>
            <q-item-section>
              <q-input
                v-model="userSearchString"
                class="q-px-sm q-pb-sm"
                placeholder="Search"
                debounce="50"
                dense
              >
                <template #prepend>
                  <q-icon name="search" />
                </template>
              </q-input>
            </q-item-section>
          </q-item>
          <q-list
            style="max-height: calc(100vh - 300px); overflow-y: scroll;"
            separator
          >
            <q-item
              v-for="user in users.data"
              :key="user.id"
              clickable
              :class="{ 'bg-responsive-grey-1': getValueForSelectedEmployee(user) }"
              @click="toggleValueForSelectedEmployee(user)"
            >
              <q-item-section>
                <q-item-label>
                  <div class="text-body1">
                    {{ user.name }}
                  </div>
                </q-item-label>
              </q-item-section>
              <q-item-section
                side
              >
                <div class="row justify-center items-center">
                  <q-checkbox
                    class="col"
                    :model-value="getValueForSelectedEmployee(user)"
                    @update:model-value="toggleValueForSelectedEmployee(user)"
                  />
                </div>
              </q-item-section>
            </q-item>
          </q-list>
        </q-card>
      </q-card-section>

      <q-card-actions class="q-pb-md row justify-around col-auto bg-responsive">
        <q-btn
          class="col text-capitalize text-bold"
          :label="selectedEmployee ? 'Transfer Tab' : 'Select Recipient'"
          color="primary"
          :text-color="$getColor(currentSite, 'primary')"
          :disable="!selectedEmployee"
          size="md"
          @click="() => employeeSelected(selectedEmployee)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'IncomingEmployeeSelectDialog',
  props: {
    maximized: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  models: {
    users: {
      fields: 'operator',
      variables () {
        return {
          userRole: 'employees',
          searchString: this.userSearchString,
          siteIds: [this.currentSite.id],
          limit: 25,
          noCount: true,
          skip: !this.currentUser
        }
      }
    }
  },
  context: ['currentUser'],
  configuration: ['currentSite'],
  emits: ['incoming-employee-selected'],
  data () {
    return {
      shown: false,
      force: false,
      selectedEmployee: null,
      userSearchString: ''
    }
  },
  methods: {
    show () {
      this.shown = true
      this.selectedEmployee = null
      this.userSearchString = ''
    },
    employeeSelected (employee) {
      this.$emit('incoming-employee-selected', employee, this.force)
      this.shown = false
    },
    toggleValueForSelectedEmployee (user) {
      if (this.selectedEmployee === user) {
        this.selectedEmployee = null
      } else {
        this.selectedEmployee = user
      }
    },
    getValueForSelectedEmployee (user) {
      return this.selectedEmployee === user
    }
  }
}
</script>
